import { render, staticRenderFns } from "./LandingNoList-V2.vue?vue&type=template&id=91bd0ea4&scoped=true"
import script from "./LandingNoList-V2.vue?vue&type=script&lang=js"
export * from "./LandingNoList-V2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91bd0ea4",
  null
  
)

export default component.exports